import { useState, useEffect, Fragment, useRef, useCallback } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner, OverlayTrigger, Tooltip, Container } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import { useForm, Controller } from "react-hook-form";
import ApiAmusementService from "../../../core/api/api.amusementService";
import Swal from "sweetalert2";
import { NumericFormat, PatternFormat } from "react-number-format";
import TextEditor from "../_Components/CkEditor/Index";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import { isMobile } from "react-device-detect";
import HTMLInput from "../_Components/HTMLInput";
import { numberRegex } from "../../../core/utils/tools";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircle";


const supplierSettlementTypeEnum = [
  { value: 1, label: "تسویه در وضعیت بلیط رزرو" },
  { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
];
const issueTicketTypeEnum = [
  { value: 1, label: "صدور بلیط خارج از سامانه" },
  { value: 2, label: "صدور بلیط توسط سامانه" },
];
const steps = ["اطلاعات آیتم رزرو", "تخفیفات و کمیسیون ها", "پایان عملیات"];
const CreateOrEditAmusementReserveItem = ({
  showModalReserveItem,
  setShowModalReserveItem,
  selectedReserveItem,
  suppliers,
  modalType, // 1:ثبت
  //2:ویرایش
  //3:کپی
}) => {
  const [services, setServices] = useState([]);
  const [currentSteps, setCurrentStep] = useState(0)
  // const [showMsg, setShowMsg] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, submitCount },
    reset,
    setValue,
    getValues,
    watch,
    register,
  } = useForm({
    defaultValues: {
      id: 0,
      defaultReserveCountPerDay: 10,
      reservationExpirationTime: "23:59",
      isDisplay: true,
      isActive: true,
      supplierSettlementType: { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
      issueTicketType: { value: 1, label: "صدور بلیط خارج از سامانه " },
      amusementServiceId: null,
      supplierId: null,
    },
  });
  const scrollableBox = useRef()

  const issueTicketTypeSelect = watch("issueTicketType");
  const supplierSettlementTypeSelect = watch("supplierSettlementType");
  const supplierAutoSettlementCheckBox = watch("supplierAutoSettlement");
  const [amusementServiceReserveItem, setAmusementServiceReserveItem] = useState();

  const supplierIdText = watch("supplierId");

  const supplierSettlementPriceText = watch("supplierSettlementPrice");
  const cleanAmount =
    typeof supplierSettlementPriceText === "string"
      ? supplierSettlementPriceText.replace(/,/g, "")
      : supplierSettlementPriceText;
  const supplierSettlementPriceformattedAmount = cleanAmount ? Number(cleanAmount).toLocaleString("en-US") : "—";

  const showMsg =
    (issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1) ||
    (issueTicketTypeSelect?.value === 1 && supplierAutoSettlementCheckBox === true);
  // useEffect(() => {
  //   if (issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect.value === 1) {
  //     setValue("supplierAutoSettlement", false);
  //   }
  // }, []);
  // Fetch all services and suppliers
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const services = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(services) && !_.isEmpty(suppliers)) {
          setServices(services);
        }
      } catch (error) {
      }
    };

    fetchServices();
  }, []);

  // حالت ویرایش
  useEffect(() => {
    const fetchReserveItem = async () => {
      if (selectedReserveItem.id !== 0 && services.length > 0) {
        try {
          const response = await ApiAmusementServiceReserveItem.get(selectedReserveItem.id);
          setValue("id", response.data.id);
          setValue("title", response.data.title);
          setValue("price", response.data.price);
          setValue("originalPrice", response.data.originalPrice);
          setValue("isActive", response.data.isActive);
          setValue("supplierAutoSettlement", response.data.supplierAutoSettlement);
          // setValue("isFullCapacity", response.data.isFullCapacity);
          setValue("defaultReserveCountPerDay", response.data.defaultReserveCountPerDay);
          setValue("tooltip", response.data.tooltip);
          setValue("ticketRules", response.data.ticketRules);
          setValue("ticketDescription", response.data.ticketDescription);
          setValue("minimumReserveCountPerDay", response.data.minimumReserveCountPerDay);
          // setValue("isDisplay", response.data.isDisplay);
          setValue("viewOrder", response.data.viewOrder);
          setValue("reservationExpirationTime", response.data.reservationExpirationTime);
          setValue("executionTime", response.data.executionTime);
          setValue("supplierSettlementPrice", response.data.supplierSettlementPrice);
          setValue("ticketPlanDetail", response.data.ticketPlanDetail);
          setValue("showReserveItemGroupTitleInTicketPlan", response.data.showReserveItemGroupTitleInTicketPlan);
          setValue("showReserveItemTitleInTicketPlan", response.data.showReserveItemTitleInTicketPlan);
          setValue(
            "supplierSettlementType",
            supplierSettlementTypeEnum.find((item) => item.value === response.data.supplierSettlementType),
          );
          setValue(
            "issueTicketType",
            issueTicketTypeEnum.find((item) => item.value === response.data.issueTicketType),
          );
          setValue("reservationByPhone", response.data.reservationByPhone);

          if (response.data.amusementServiceId) {
            const initialService = services.find((service) => service.id === response.data.amusementServiceId);
            if (initialService) {
              const selectedOption = {
                value: initialService.id,
                label: initialService.name,
              };
              setValue("amusementServiceId", selectedOption);
            }
          }
          if (response.data.supplierId) {
            const initialSupplier = suppliers.find((supplier) => supplier.id === response.data.supplierId);
            if (initialSupplier) {
              const selectedOption = {
                value: initialSupplier.id,
                label: initialSupplier.companyName,
              };
              setValue("supplierId", selectedOption);
            }
          }
        } catch (error) {
        }
      } else {
        const res = await ApiPromoCategory.getAllPromoCategoryAndCommission()
        setAmusementServiceReserveItem(res)
        reset({
          id: 0,
          defaultReserveCountPerDay: 10,
          reservationExpirationTime: "23:59",
          supplierSettlementType: { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
          issueTicketType: { value: 1, label: "صدور بلیط خارج از سامانه " },
          amusementServiceId: null,
          supplierId: null,
        });
      }
    };

    fetchReserveItem();
  }, [selectedReserveItem, services, setValue]);

  const handleClose = () => {
    setShowModalReserveItem(false);
    if (submitCount)
      document.getElementById("submitButton").click();

  };

  const onSubmit = async (data) => {
    if (currentSteps == 2) {
      document.getElementById("submitButton").click();
      SwalMessage({ title: "آیتم جدید اضافه شد", iSsuccess: true });
      setShowModalReserveItem(false);
      return
    }
    // if (data.supplierId !== null && !data.supplierSettlementPrice) {
    //   setErrorForSupplierSettlementPrice(true);
    //   return;
    // }
    if (currentSteps == 0) {
      if (data.supplierId !== null && Number(data.supplierSettlementPrice) === 0) {
        const resultSweetAlert = await Swal.fire({
          // title: "تایید عملیات درج",
          text: "تامین کننده تفریح انتخاب شده و مبلغ پرداختی به تامین کننده صفر می باشد. در صورت مغایرت مبلغ پرداخت به تامین کننده جهت جلوگیری از بروز مشکل آن را تغییر دهید در غیراین صورت روی دکمه تایید کلیک نمایید",
          showDenyButton: true,
          showCancelButton: false,
          icon: "question",
          confirmButtonText: "تایید",
          denyButtonText: "انصراف",
          // cancelButtonText: "انصراف",
          customClass: {
            actions: "my-actions",
            //cancelButton: "order-1 right-gap btn btn-secondary px-3",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        });

        if (!resultSweetAlert.isConfirmed) {
          return;
        }
      }
      data.originalPrice =
        data.originalPrice && data.originalPrice.length > 0
          ? data.originalPrice.replaceAll(" ", "").replaceAll(",", "")
          : data.originalPrice;
      data.price = data.price && data.price.length > 0 ? data.price.replaceAll(" ", "").replaceAll(",", "") : data.price;
      data.supplierSettlementPrice =
        data.supplierSettlementPrice && data.supplierSettlementPrice.length > 0
          ? data.supplierSettlementPrice.replaceAll(" ", "").replaceAll(",", "")
          : data.supplierSettlementPrice;
      data.supplierSettlementType = data?.supplierSettlementType?.value;
      data.issueTicketType = data?.issueTicketType?.value;
      data.amusementServiceId = data.amusementServiceId?.value;
      data.supplierId = data.supplierId?.value;
      data.minimumReserveCountPerDay = +data.minimumReserveCountPerDay;

      if (Number(data.originalPrice) < Number(data.price)) {
        SwalMessage({ title: "قیمت نمی تواند بیشتر از قیمت اصلی آیتم باشد.", iSsuccess: false, timer: 5000 });
        return;
      }
      try {
        let response = null;
        if (modalType === 1) {
          response = await ApiAmusementServiceReserveItem.create(data);
          if (modalType == 1) {
            setValue("amusementServiceReserveItemId", response.data)
            setCurrentStep(1)
            const maxTakhfif = +(getValues("price").replaceAll(",", "")) - +((getValues("supplierSettlementPrice") || "0").replaceAll(",", ""))
            amusementServiceReserveItem.forEach(category => {
              category.promoCategoryCommision.forEach(comission => {
                setValue(`commissionPercent_${comission.id}`, 0)
                setValue(`commissionAmount_${comission.id}`, formatNumber(0))
                setValue(`discountAmount_${category.id}_${comission.id}`, formatNumber(0))
                setValue(`discountPercent_${category.id}_${comission.id}`, 0)
                setValue(`profit_${category.id}_${comission.id}`, formatNumber(maxTakhfif))
              })
              setValue(`discountAmount_${category.id}_undefined`, formatNumber(0))
              setValue(`discountPercent_${category.id}_undefined`, 0)
              setValue(`profit_${category.id}_undefined`, formatNumber(maxTakhfif))
            })
          }
          return
        } else if (modalType === 2 && data.id > 0) {
          response = await ApiAmusementServiceReserveItem.update(data.id, data);
        } else if (modalType === 3) {
          response = await ApiAmusementServiceReserveItem.create(data);
        }
        if (response.succeeded == true) document.getElementById("submitButton").click();
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        handleClose()
      } catch (error) {
      }
    }
    else if (currentSteps == 1) {
      //************* چک کردن سود نهایی در صورت منفی شدن آلرت نشون میده
      const profitsElements = document.querySelectorAll("input[title='سود نهایی']")
      const profits = []
      for (const el of profitsElements) {
        profits.push(+el.value?.replaceAll(",", ""))
      }
      if (profits.some(profit => profit < 0)) {
        const resultSweetAlert = await Swal.fire({
          title: "سود منفی",
          html: `مبلغ سود نهایی سیستم ${amusementServiceReserveItem?.length > 0 ? "در یک یا چند گروه تخفیف" : ""} منفی شده است در نتیجه پس از رزرو این آیتم به جای سود ضرر میکنیم. <br/> آیا ثبت نهایی انجام شود؟`,
          showDenyButton: true,
          showCancelButton: false,
          icon: "error",
          confirmButtonText: "تایید",
          denyButtonText: "انصراف",
          // cancelButtonText: "انصراف",
          customClass: {
            actions: "my-actions",
            //cancelButton: "order-1 right-gap btn btn-secondary px-3",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusConfirm: true,
        });

        if (!resultSweetAlert.isConfirmed) {
          return;
        }
      }

      const structuredData = {
        amusementServiceReserveItemId: data.amusementServiceReserveItemId,
        promoCategories: [],
        promoCategoryCommissions: []
      };
      //******************** گروه های تخفیف و کمیسیون ها*/
      amusementServiceReserveItem.forEach((category) => {
        const commissionObjs = category.promoCategoryCommision.length ? category.promoCategoryCommision : [1];
        commissionObjs.forEach((commissionObj) => {
          // گروه تخفیف
          var existingCategory = structuredData.promoCategories.find(a => a.id == category.id);
          if (!existingCategory) {
            let discountAmount = +getValues(`discountAmount_${category.id}_${commissionObj.id}`)?.replaceAll(",", "") || 0;
            structuredData.promoCategories.push({
              promoCategoryId: category.id,
              discountPrice: discountAmount,
              discountPricePercent: 0,
            });
          }
          // کمیسیون
          var existingCommission = structuredData.promoCategoryCommissions.find(a => a.id == commissionObj.id);
          if (!existingCommission) {
            let commissionAmount = +(getValues(`commissionAmount_${commissionObj.id}`)?.replaceAll(",", "")) || 0;
            structuredData.promoCategoryCommissions.push({
              promoCategoryCommissionId: commissionObj.id,
              discountPriceCommission: commissionAmount,
            });
          }
        });
      });
      try {
        let response = await ApiPromoCategory.addPromoCategoryAmusementServiceByReserveItemId(structuredData);
        if (response.succeeded == true)
          setCurrentStep(2)
      } catch (error) {
      }
    }
  };

  const handleChangeIsNumber = (event, onChange) => {
    const value = event.target.value;
    const label = event.target.closest(".MuiTextField-root")?.querySelector("label")?.innerHTML
    // فقط مقادیر عددی بزرگتر از 0 مجاز باشند
    if (/^[0-9]\d*$|^$/.test(value)) {
      // فیلد تماس تلفنی باید 11 رقم باشد
      if (label == "تماس تلفنی" && (value.length > 11 || value.length < 0)) return
      onChange(value); // مقدار ورودی را به‌روزرسانی می‌کنیم
    }
  };

  // محاسبه سود با تغییر تخفیف و کمیسیون
  const updateProfit = (newValue, fieldName, id, commissionId) => {
    if (!numberRegex.test(newValue.replaceAll(",", "")) && newValue) {
      return
    }
    //  فقط عدد
    const numberValue = String(newValue).replace(/[^0-9.]/g, "");
    const price = getValues("price") ? +(getValues("price").replaceAll(",", "")) : 0;
    const supplierSettlementPrice = +(getValues("supplierSettlementPrice")?.replaceAll(",", "")) || 0;

    const baseProfit = price - supplierSettlementPrice;

    let discountAmount = 0;
    let commissionAmount = 0;

    // --- درصد یا مبلغ تخفیف ---
    if (fieldName.includes("discountAmount_")) {
      discountAmount = newValue.replaceAll(",", "");
      const discountPercent = baseProfit !== 0 ? ((discountAmount.replaceAll(",", "") / baseProfit) * 100) : 0;
      const discountPercentageStr = Number.isInteger(+discountPercent) ? discountPercent : (+discountPercent).toFixed(2);

      setValue(fieldName, formatNumber(numberValue));
      setValue(`discountPercent_${id}_${commissionId}`, discountPercentageStr);

    } else if (fieldName.includes("discountPercent_")) {
      const percent = newValue;
      discountAmount = (baseProfit * percent) / 100;
      discountAmount = discountAmount < 0 ? 0 : discountAmount; // مبلغ تخفیف منفی نشود
      setValue(fieldName, numberValue); // درصد را بدون کاما نگه دار
      setValue(
        `discountAmount_${id}_${commissionId}`,
        formatNumber(discountAmount.toFixed())
      );
    }

    // --- درصد یا مبلغ کمیسیون ---
    else if (fieldName.includes("commissionAmount_")) {
      commissionAmount = newValue.replaceAll(",", "");
      const commissionPercent = baseProfit !== 0 ? (commissionAmount.replaceAll(",", "") / baseProfit) * 100 : 0;
      const commissionPercentageStr = Number.isInteger(commissionPercent) ? commissionPercent : (+commissionPercent).toFixed(2);

      setValue(fieldName, formatNumber(numberValue));
      setValue(`commissionPercent_${commissionId}`, commissionPercentageStr);

    } else if (fieldName.includes("commissionPercent_")) {
      const percent = newValue;
      commissionAmount = (baseProfit * percent) / 100;
      commissionAmount = commissionAmount < 0 ? 0 : commissionAmount; // مبلغ کمیسیون منفی نشود
      setValue(fieldName, numberValue);
      setValue(`commissionAmount_${commissionId}`, formatNumber(commissionAmount.toFixed()));
    }
    // --- سود نهایی ---
    const finalDiscountAmount =
      discountAmount ||
      +(String(getValues(`discountAmount_${id}_${commissionId}`))?.replaceAll(",", "")) ||
      0;

    const finalCommissionAmount =
      commissionAmount ||
      +(String(getValues(`commissionAmount_${commissionId}`))?.replaceAll(",", "")) ||
      0;
    const finalProfit = baseProfit - finalDiscountAmount - finalCommissionAmount;
    setValue(`profit_${id}_${commissionId}`, formatNumber(finalProfit.toFixed()));
  };

  const formatNumber = (value) => {
    const stringValue = String(value);
    return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const percentOnInput = useCallback((e, inputName) => {
    if (e.target.value > 100) e.target.value = 100;
    if (!numberRegex.test(e.target.value) && e.target.value) {
      e.target.value = getValues(inputName)
      return
    }
  }, [])
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered show={showModalReserveItem} size="xl" onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {" "}
                {modalType === 2 ? "ویرایش آیتم رزرو" : "ایجاد آیتم رزرو جدید"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {modalType == 1 ? <>
                <Container className="text-center">
                  <div className="justify-content-center mb-4 stepper-row d-flex">
                    {steps.map((label, index) => (
                      <Fragment key={index}>
                        <Col xs="auto" className="step-container position-relative px-2">
                          <div className={`step-circle ${index <= currentSteps ? "active" : ""}`}>{index + 1}</div>
                          <div className={`step-label text-small-1 ${index === currentSteps ? "active" : ""}`}>
                            {label}
                          </div>
                          {index < steps.length - 1 && (
                            <div style={{ width: 90 }} className={`connector ${index < currentSteps ? "active" : ""}`}></div>
                          )}
                        </Col>
                      </Fragment>
                    ))}
                  </div>
                </Container>
                <div className="stepper">
                  <div className=" border-bottom pb-5 mb-5">
                    <div className="step d-flex flex-column flex-md-row align-items-center justify-content-center">
                      <h4 className="mb-0">
                        {currentSteps === 0 && "مرحله 1 : اطلاعات آیتم رزرو"}
                        {currentSteps === 1 && "مرحله 2 : تخفیفات و کمیسیون ها"}
                        {currentSteps === 2 && "مرحله 3 : پایان عملیات"}
                      </h4>
                      <p className="mb-0 px-2">
                        {currentSteps === 0
                          && "(در این مرحله اطلاعات اصلی آیتم رزرو خود را وارد نمایید.)"}
                        {
                          currentSteps === 1 && "(در این مرحله تخفیفات و کمیسیون ها را وارد نمایید.)"}
                        {
                          currentSteps === 2 && "(در این مرحله آیتم رزرو شما با موفقیت ثبت شد.)"}
                      </p>
                    </div>
                  </div>
                  {currentSteps == 0 &&
                    <Row>
                      <Col xl="6">
                        <div className="rounded-2 px-3 py-1 pb-5" style={{ border: "3px solid #81aced" }}>
                          <div
                            className="bg-white px-3 position-absolute d-inline-block text-primary"
                            style={{ marginTop: "-14px", width: "auto" }}
                          >
                            اطلاعات اصلی
                    </div>
                          <Row className="mt-3">
                            <Col xs="12" className="pl-0">
                              <FormControlLabel
                                className="mb-0"
                                control={
                                  <Controller
                                    control={control}
                                    name={"isActive"}
                                    render={({
                                      field: { onChange, onBlur, value, name, ref },
                                      fieldState: { invalid, isTouched, isDirty, error },
                                    }) => (
                                      <Checkbox
                                        color="primary"
                                        onBlur={onBlur}
                                        onChange={onChange}
                                        checked={value || false}
                                        inputRef={ref}
                                      />
                                    )}
                                  />
                                }
                                label="فعال / غیرفعال کردن آیتم"
                              />
                            </Col>
                            <Col xs="12" xl="6" style={{ zIndex: "4" }}>
                              <Controller
                                name="amusementServiceId"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                  <SelectComponent
                                    name="service"
                                    className="w-100 mt-2"
                                    variant="outlined"
                                    size="small"
                                    placeholder="انتخاب تفریح"
                                    options={services?.map((item) => ({
                                      value: item.id,
                                      label: item.name,
                                    }))}
                                    value={getValues("amusementServiceId") || ""}
                                    onChange={onChange}
                                  />
                                )}
                              />
                              {errors.amusementServiceId && (
                                <div className="mt-2 pl-4 text-danger">**لطفا تفریح را وارد نمایید</div>
                              )}
                            </Col>

                            <Col xs="12" xl="6">
                              <Controller
                                name="title"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                                  <TextField
                                    label="عنوان"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    className="m-0 mt-5 mt-xl-2"
                                    value={value || ""}
                                    onInput={onChange}
                                  />
                                )}
                              />
                              {errors.title && <div className="mt-2 pl-4 text-danger">**لطفا عنوان را وارد نمایید</div>}
                            </Col>

                            <Col xs="12" xl="12" className="mt-3 mb-2 font-size-sm">
                              <div className="mb-2">توضیحات قابل نمایش در tooltip</div>
                              <div>
                                {" "}
                                <Controller
                                  name="tooltip"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <TextEditor
                                      data={value || ""}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        onChange(data);
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                          <div
                            className="bg-white px-3 position-absolute d-inline-block text-primary"
                            style={{ marginTop: "-14px", width: "auto" }}
                          >
                            قیمت گذاری
                    </div>
                          <Row className="mt-3">
                            <Col xs="12" xl="6">
                              <Controller
                                name="originalPrice"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    customInput={TextField}
                                    label="قیمت مصوب"
                                    type="search"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    value={value || ""}
                                    onChange={onChange}
                                    thousandSeparator=","
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                  />
                                )}
                              />
                              {errors.originalPrice && <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                            </Col>
                            <Col xs="12" xl="6">
                              <Controller
                                name="price"
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    customInput={TextField}
                                    label="قیمت فروش"
                                    margin="normal"
                                    variant="outlined"
                                    type="search"
                                    size="small"
                                    value={value || ""}
                                    onChange={onChange}
                                    thousandSeparator=","
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                  />
                                )}
                              />
                              {errors.price && <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                            </Col>
                            <Col xs="12" xl="3">
                              <Controller
                                name="minimumReserveCountPerDay"
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    label="حداقل تعداد"
                                    type="text"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    value={field.value || ""}
                                    onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" xl="3">
                              <Controller
                                name="defaultReserveCountPerDay"
                                control={control}
                                rules={{
                                  required: true,
                                }}
                                render={({ field }) => (
                                  <TextField
                                    label="ظرفیت روزانه"
                                    type="text"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    value={field.value || ""}
                                    onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                                  />
                                )}
                              />
                              {errors.defaultReserveCountPerDay && (
                                <div className="mt-2 pl-4 text-danger">**لطفاظرفیت روزانه را وارد نمایید</div>
                              )}
                            </Col>
                            <Col xs="12" xl="6">
                              <Controller
                                name="reservationExpirationTime"
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { onChange, value } }) => (
                                  <PatternFormat
                                    customInput={TextField}
                                    label="ساعت اتمام فروش"
                                    size="small"
                                    type="search"
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                    margin="normal"
                                    value={value || ""}
                                    variant="outlined"
                                    onChange={onChange}
                                    placeholder="00:00"
                                    format="##:##"
                                    allowEmptyFormatting={false}
                                    defaultValue="23:59"
                                  />
                                )}
                              />
                              {errors.reservationExpirationTime && (
                                <div className="mt-2 pl-4 text-danger">**لطفا ساعت اتمام فروش را وارد نمایید</div>
                              )}
                            </Col>
                            <Col xs="12" xl="6">
                              <Controller
                                name="executionTime"
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { onChange, value } }) => (
                                  <PatternFormat
                                    customInput={TextField}
                                    label="زمان انجام برنامه"
                                    size="small"
                                    margin="normal"
                                    type="search"
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                    value={value || ""}
                                    variant="outlined"
                                    onChange={onChange}
                                    placeholder="00:00"
                                    format="##:##"
                                    allowEmptyFormatting={false}
                                    defaultValue="23:59"
                                  />
                                )}
                              />
                            </Col>
                            {/* <Col xs="12">
                                        <Controller
                                            name="defaultReserveCountPerDay"
                                            control={control}
                                            //rules={{ required: true }}
                                            render={({ field: { onChange, value } }) => (
                                                <TextField
                                                    label="حداکثر تعداد فروش در روز"
                                                    margin="normal"
                                                    variant="outlined"
                                                    size="small"
                                                    value={_.toInteger(value) || ""}
                                                    onChange={onChange}
                                                />
                                            )}
                                        />
                                       
                                    </Col> */}

                            <Col xs="12" xl="6" className="d-flex align-items-center">
                              <Controller
                                name="reservationByPhone"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <TextField
                                    label="تماس تلفنی"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    value={value || ""}
                                    onInput={(e) => handleChangeIsNumber(e, onChange)}
                                  />
                                )}
                              />
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="tooltip-top">
                                    در صورتی که این فیلد پر شود، آیتم موردنظر در سایت تفریحان قابل رزرو به صورت آنلاین نیست و
                                    عنوان نمایشی « رزرو تلفنی » نمایش داده می شود.
                            </Tooltip>
                                }
                              >
                                <i className="fa fa-info-circle ml-1 mt-1"></i>
                              </OverlayTrigger>
                            </Col>
                          </Row>
                        </div>
                        <div className="rounded-2 px-3 mt-5 py-1" style={{ border: "3px solid #81aced" }}>
                          <div
                            className="bg-white px-3 position-absolute d-inline-block text-primary"
                            style={{ marginTop: "-14px", width: "auto" }}
                          >
                            تسویه و صدور بلیط{" "}
                          </div>
                          <Row className="mt-3">
                            <Col xs="12" xl="6" style={{ zIndex: "3" }}>
                              <Controller
                                name="supplierId"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <SelectComponent
                                    className="w-100 mt-5"
                                    variant="outlined"
                                    size="small"
                                    placeholder="تامین کننده"
                                    options={suppliers?.map((item) => ({
                                      value: item.id,
                                      label: item.companyName,
                                    }))}
                                    value={value}
                                    onChange={onChange}
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" xl="6">
                              <Controller
                                name="supplierSettlementPrice"
                                control={control}
                                rules={{ required: supplierIdText ? true : false }}
                                render={({ field: { onChange, value } }) => (
                                  <NumericFormat
                                    customInput={TextField}
                                    label="قیمت تسویه با تامین کننده"
                                    margin="normal"
                                    variant="outlined"
                                    size="small"
                                    type="search"
                                    value={value}
                                    onChange={onChange}
                                    thousandSeparator=","
                                    onKeyDown={(e) => {
                                      if (e.key === "Escape") {
                                        e.stopPropagation()
                                      }
                                    }}
                                  />
                                )}
                              />
                              {errors.supplierSettlementPrice && (
                                <div className="mt-2 pl-4 text-danger">**قیمت تسویه با تامین کننده را وارد کنید</div>
                              )}
                              {/* {errorForSupplierSettlementPrice && (
                          <div className="text-danger">**قیمت تسویه با تامین کننده را وارد کنید</div>
                        )} */}
                            </Col>
                            <Col xs="12" xl="6">
                              <Controller
                                name="supplierSettlementType"
                                control={control}
                                // rules={{ required: true, }}
                                render={({ field: { onChange } }) => (
                                  <SelectComponent
                                    name="supplierSettlementType"
                                    className="w-100 mt-2"
                                    variant="outlined"
                                    size="small"
                                    placeholder="نحوه تسویه با تامین کننده"
                                    options={supplierSettlementTypeEnum}
                                    value={getValues("supplierSettlementType") || ""}
                                    onChange={onChange}
                                  />
                                )}
                              />
                            </Col>

                            <Col xs="12" xl="6">
                              <Controller
                                name="issueTicketType"
                                control={control}
                                // rules={{ required: true, }}
                                render={({ field: { onChange } }) => (
                                  <SelectComponent
                                    name="issueTicketType"
                                    className="w-100 mt-3"
                                    variant="outlined"
                                    size="small"
                                    placeholder="نوع صدور بلیط"
                                    options={issueTicketTypeEnum}
                                    value={getValues("issueTicketType") || ""}
                                    onChange={onChange}
                                  />
                                )}
                              />
                            </Col>

                            <Col
                              xs="12"
                              className={`pl-0 ${issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1 ? "opacity-50 " : ""}`}
                            >
                              <FormControlLabel
                                control={
                                  <Controller
                                    control={control}
                                    name={"supplierAutoSettlement"}
                                    render={({
                                      field: { onChange, onBlur, value, name, ref },
                                      fieldState: { invalid, isTouched, isDirty, error },
                                    }) => (
                                      <Checkbox
                                        color="primary"
                                        onBlur={onBlur}
                                        onChange={onChange}
                                        checked={
                                          issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1
                                            ? false
                                            : value || false
                                        }
                                        inputRef={ref}
                                        disabled={
                                          issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1
                                        }
                                      />
                                    )}
                                  />
                                }
                                label="تسویه خودکار با تامین کننده"
                              />
                            </Col>
                            {showMsg && (
                              <Col className="pb-3">
                                <div className="border-primary rounded-2 px-5 py-3 text-primary bg-light-primary">
                                  تسویه با تامین کننده ی {supplierIdText?.label} به مبلغ{" "}
                                  {supplierSettlementPriceformattedAmount} تومان به صورت خودکار انجام می شود.
                          </div>
                              </Col>
                            )}
                          </Row>
                        </div>
                      </Col>
                      <Col xl="6" className="mt-5 mt-xl-0">
                        <div className="rounded-2 px-3  py-1" style={{ border: "3px solid #81aced" }}>
                          <div
                            className="bg-white px-3 position-absolute d-inline-block text-primary"
                            style={{ marginTop: "-14px", width: "auto" }}
                          >
                            متن های درج شده روی بلیط{" "}
                          </div>
                          <Row className="mt-4">
                            <Col xs="12" xl="12" className=" mb-2 font-size-sm">
                              <div className="mb-2"> متن قوانین روی بلیط</div>
                              <div>
                                <Controller
                                  name="ticketRules"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <TextEditor
                                      data={value || ""}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        onChange(data);
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Col>

                            <Col xs="12" xl="12" className="mt-5 mb-5 font-size-sm">
                              <div className="mb-2"> متن توضیحات روی بلیط</div>
                              <div>
                                <Controller
                                  name="ticketDescription"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <TextEditor
                                      data={value || ""}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        onChange(data);
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Col>

                            <Col xs="12" xl="12" className="mt-5 pb-3 position-relative">
                              <div
                                className="bg-white font-size-sm position-absolute px-2"
                                style={{ top: "-10px", right: "20px" }}
                              >
                                متن نمایشی برنامه و سانس در بلیط
                        </div>
                              <div className=" p-3" style={{ border: "1px solid #ccc", borderRadius: "2px" }}>
                                <FormControlLabel
                                  className="mb-0"
                                  control={
                                    <Controller
                                      control={control}
                                      name={"showReserveItemGroupTitleInTicketPlan"}
                                      render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { invalid, isTouched, isDirty, error },
                                      }) => (
                                        <Checkbox
                                          color="primary"
                                          onBlur={onBlur}
                                          onChange={onChange}
                                          checked={value || false}
                                          inputRef={ref}
                                        />
                                      )}
                                    />
                                  }
                                  label=" نمایش گروه آیتم رزرو در برنامه و سانس"
                                />{" "}
                                <FormControlLabel
                                  className="mb-0"
                                  control={
                                    <Controller
                                      control={control}
                                      name={"showReserveItemTitleInTicketPlan"}
                                      render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { invalid, isTouched, isDirty, error },
                                      }) => (
                                        <Checkbox
                                          color="primary"
                                          onBlur={onBlur}
                                          onChange={onChange}
                                          checked={value || false}
                                          inputRef={ref}
                                        />
                                      )}
                                    />
                                  }
                                  label=" نمایش عنوان آیتم رزرو در برنامه و سانس"
                                />
                                <div className="mb-1 mt-2">متن دلخواه در ادامه برنامه و سانس در بلیط</div>
                                <Controller
                                  name="ticketPlanDetail"
                                  control={control}
                                  render={({ field: { onChange, value } }) => (
                                    <TextEditor
                                      data={value || ""}
                                      onChange={(event, editor) => {
                                        const data = editor.getData();
                                        onChange(data);
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  }
                  {
                    currentSteps == 1 &&
                    <div className="position-relative">
                      <Row ref={scrollableBox} className="mt-7 flex-nowrap overflow-x-auto">
                        {/* ====== گروه‌های تخفیف ====== */}
                        <Col xs="12" xl="5">
                          <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                            <div
                              className="bg-white px-3 position-absolute d-inline-block text-primary"
                              style={{ marginTop: "-14px", width: "auto" }}
                            >
                              گروه‌های تخفیف
                    </div>
                            {amusementServiceReserveItem?.map((category) => {
                              const commissionObjs = category.promoCategoryCommision.length ? category.promoCategoryCommision : [1];
                              return commissionObjs.map((commissionObj) => (
                                <Row
                                  style={{
                                    marginTop: 9.75
                                  }}
                                  key={`discount_${category.id}_${commissionObj.id}`}
                                >
                                  <div className="px-3">
                                    <div className="mb-2">
                                      <strong>{`${category.name}`}</strong>
                                    </div>
                                    <div >
                                      <Row className="align-items-center">
                                        {/* مبلغ تخفیف */}
                                        <Col xs="6">
                                          <div className="d-flex align-items-center">
                                            <label
                                              className="small mb-0 me-1"
                                              style={{ width: "60px" }}
                                            >
                                              مبلغ:
                                    </label>
                                            <HTMLInput
                                              placeholder="مبلغ تخفیف"
                                              registeredParams={{
                                                ...register(
                                                  `discountAmount_${category.id}_${commissionObj.id}`,
                                                )
                                              }}
                                              onInput={(e) => {
                                                if (!numberRegex.test(e.target.value.replaceAll(",", "")) && e.target.value) {
                                                  e.stopPropagation()
                                                  e.target.value = getValues(`discountAmount_${category.id}_${commissionObj.id}`)
                                                  return
                                                }
                                              }}
                                              onChange={(e) => {
                                                register(
                                                  `discountAmount_${category.id}_${commissionObj.id}`,
                                                ).onChange(e);
                                                updateProfit(
                                                  e.target.value,
                                                  `discountAmount_${category.id}_${commissionObj.id}`,
                                                  category.id,
                                                  commissionObj.id
                                                );
                                              }}
                                              margin="normal"
                                              variant="outlined"
                                              size="small"
                                              className="form-control text-left"
                                              title="مبلغ تخفیف"
                                              dir="ltr"
                                            />
                                          </div>
                                          <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}></div>
                                        </Col>

                                        {/* درصد تخفیف */}
                                        <Col xs="6">
                                          <div className="d-flex align-items-center">
                                            <label
                                              className="small mb-0 me-1"
                                              style={{ width: "60px" }}
                                            >
                                              درصد:
                                    </label>
                                            <HTMLInput
                                              placeholder="درصد تخفیف"
                                              registeredParams={{
                                                ...register(
                                                  `discountPercent_${category.id}_${commissionObj.id}`,
                                                  { max: { value: 100 }, min: { value: 0 } }
                                                )
                                              }}
                                              onInput={(e) => {
                                                percentOnInput(e, `discountPercent_${category.id}_${commissionObj.id}`)
                                              }}
                                              onChange={(e) => {
                                                register(`discountPercent_${category.id}_${commissionObj.id}`,
                                                ).onChange(e);
                                                updateProfit(
                                                  e.target.value,
                                                  `discountPercent_${category.id}_${commissionObj.id}`,
                                                  category.id,
                                                  commissionObj.id
                                                );
                                              }}
                                              margin="normal"
                                              variant="outlined"
                                              size="small"
                                              className="form-control text-center"
                                              title="درصد تخفیف"
                                              dir="ltr"
                                            />
                                          </div>
                                          <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}>{errors[`discountPercent_${category.id}_${commissionObj.id}`] && "نامعتبر است (باید بین 0 تا 100 باشد)"}</div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Row>
                              ));
                            })}
                          </div>
                        </Col>

                        {/* ====== کمیسیون‌ها ====== */}
                        <Col xs="12" xl="5">
                          <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                            <div
                              className="bg-white px-3 position-absolute d-inline-block text-primary"
                              style={{ marginTop: "-14px", width: "auto" }}
                            >
                              کمیسیون‌ها
                    </div>
                            {amusementServiceReserveItem?.flatMap((category) =>
                              (category.promoCategoryCommision.length ? category.promoCategoryCommision : [1]).map((commissionObj) => (
                                <Row
                                  style={{
                                    marginTop: 9.75
                                  }}
                                  className={`${typeof commissionObj != "object" && "invisible"}`}
                                  key={`commission_${category.id}_${commissionObj.id}`}
                                >
                                  <div className="px-3">
                                    <div className="mb-2">
                                      <strong>{`${commissionObj.name}`}</strong>
                                    </div>
                                    <div>
                                      <Row className="align-items-center">
                                        {/* مبلغ کمیسیون */}
                                        <Col xs="6">
                                          <div className="d-flex align-items-center">
                                            <label
                                              className="small mb-0 me-1"
                                              style={{ width: "60px" }}
                                            >
                                              مبلغ:
                                    </label>
                                            <HTMLInput
                                              placeholder="مبلغ کمیسیون"
                                              registeredParams={{
                                                ...register(
                                                  `commissionAmount_${commissionObj.id}`
                                                )
                                              }}
                                              onInput={(e) => {
                                                if (!numberRegex.test(e.target.value.replaceAll(",", "")) && e.target.value) {
                                                  e.stopPropagation()
                                                  e.target.value = getValues(`commissionAmount_${commissionObj.id}`)
                                                  return
                                                }
                                              }}
                                              onChange={(e) => {
                                                register(
                                                  `commissionAmount_${commissionObj.id}`
                                                ).onChange(e);
                                                updateProfit(
                                                  e.target.value,
                                                  `commissionAmount_${commissionObj.id}`,
                                                  category.id,
                                                  commissionObj.id
                                                );
                                              }}
                                              margin="normal"
                                              variant="outlined"
                                              size="small"
                                              className="form-control text-left"
                                              title="مبلغ کمیسیون"
                                              dir="ltr"
                                            />
                                          </div>
                                          <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}></div>
                                        </Col>

                                        {/* درصد کمیسیون */}
                                        <Col xs="6">
                                          <div className="d-flex align-items-center">
                                            <label
                                              className="small mb-0 me-1"
                                              style={{ width: "60px" }}
                                            >
                                              درصد:
                                    </label>
                                            <HTMLInput
                                              placeholder="درصد کمیسیون"
                                              registeredParams={{
                                                ...register(
                                                  `commissionPercent_${commissionObj.id}`,
                                                  { max: { value: 100 }, min: { value: 0 } }
                                                )
                                              }}
                                              onInput={(e) => {
                                                percentOnInput(e, `commissionPercent_${commissionObj.id}`)
                                              }}
                                              onChange={(e) => {
                                                register(
                                                  `commissionPercent_${commissionObj.id}`
                                                ).onChange(e);
                                                updateProfit(
                                                  e.target.value,
                                                  `commissionPercent_${commissionObj.id}`,
                                                  category.id,
                                                  commissionObj.id
                                                );
                                              }}
                                              margin="normal"
                                              variant="outlined"
                                              size="small"
                                              dir="ltr"
                                              className="form-control text-center"
                                              title="درصد کمیسیون"
                                            />
                                          </div>
                                          <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}>{errors[`commissionPercent_${commissionObj.id}`] && "نامعتبر است (باید بین 0 تا 100 باشد)"}</div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Row>
                              ))
                            )}
                          </div>
                        </Col>

                        {/* ====== سود نهایی ====== */}
                        <Col xs="5" xl="2">
                          <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                            <div
                              className="bg-white px-3 position-absolute d-inline-block text-primary"
                              style={{ marginTop: "-14px", width: "auto" }}
                            >
                              سود نهایی
                        </div>
                            {amusementServiceReserveItem?.flatMap((category) =>
                              (category.promoCategoryCommision.length ? category.promoCategoryCommision : [1]).map((commissionObj) => {
                                const profitValue = watch(`profit_${category.id}_${commissionObj.id}`) || "0";

                                return (
                                  <Row
                                    style={{ marginTop: isMobile ? 33.75 : 35.75 }}
                                    key={`profit_${category.id}_${commissionObj.id}`}
                                  >
                                    <div className="px-3">
                                      <Row className="align-items-center">
                                        <Col xs="12">
                                          <div className="d-flex align-items-center">
                                            <HTMLInput
                                              placeholder="سود نهایی"
                                              registeredParams={{
                                                ...register(
                                                  `profit_${category.id}_${commissionObj.id}`
                                                )
                                              }}
                                              margin="normal"
                                              variant="outlined"
                                              size="small"
                                              className="form-control text-left"
                                              title="سود نهایی"
                                              isDanger={(+profitValue.replaceAll(",", "") || 0) <= 0
                                                && true
                                              }
                                              dir="ltr"
                                              disabled
                                            />
                                          </div>
                                          <div className="mt-2 text-right text-danger" style={{ fontSize: 10, height: 15 }}></div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Row>
                                );
                              })
                            )}

                          </div>
                        </Col>

                      </Row>
                      {isMobile && <div
                        className="btn-group position-absolute w-25"
                        role="group"
                        style={{
                          bottom: -13,
                          left: "50%",
                          transform: "translateX(-50%)",
                          backgroundColor: "white"
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-outline-primary mr-5 rounded-3 fs-1"
                          style={{
                            height: 28,
                          }}
                          onClick={() => {
                            scrollableBox.current.scrollBy({
                              left: 200,
                              behavior: "smooth"
                            })
                          }}
                        >
                          <p className="position-relative" style={{
                            top: -8,
                            transform: "scaleX(50%)"
                          }}>
                            {"<"}
                          </p>
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-primary rounded-3 fs-1"
                          style={{
                            height: 28,
                          }}
                          onClick={() => {
                            scrollableBox.current.scrollBy({
                              left: -200,
                              behavior: "smooth"
                            })
                          }}
                        >
                          <p className="position-relative" style={{
                            top: -8,
                            transform: "scaleX(50%)"
                          }}>
                            {">"}
                          </p>
                        </button>
                      </div>}
                    </div>
                  }
                  {currentSteps == 2 &&
                    <div className="d-flex align-items-center justify-content-center my-5">
                      <div className="bg-light-success text-success rounded-3 py-3 px-5 mt-5 fs-medium">
                        <CheckCircleOutlineIcon />
                        <span className="mx-1">آیتم رزرو شما با موفقیت ثبت و تخفیفات و کمیسیون آن نیز ذخیره شد.</span>
                      </div>
                    </div>
                  }
                </div>
              </> :
                <Row>
                  <Col xl="6">
                    <div className="rounded-2 px-3 py-1 pb-5" style={{ border: "3px solid #81aced" }}>
                      <div
                        className="bg-white px-3 position-absolute d-inline-block text-primary"
                        style={{ marginTop: "-14px", width: "auto" }}
                      >
                        اطلاعات اصلی
       </div>
                      <Row className="mt-3">
                        <Col xs="12" className="pl-0">
                          <FormControlLabel
                            className="mb-0"
                            control={
                              <Controller
                                control={control}
                                name={"isActive"}
                                render={({
                                  field: { onChange, onBlur, value, name, ref },
                                  fieldState: { invalid, isTouched, isDirty, error },
                                }) => (
                                  <Checkbox
                                    color="primary"
                                    onBlur={onBlur}
                                    onChange={onChange}
                                    checked={value || false}
                                    inputRef={ref}
                                  />
                                )}
                              />
                            }
                            label="فعال / غیرفعال کردن آیتم"
                          />
                        </Col>
                        <Col xs="12" xl="6" style={{ zIndex: "4" }}>
                          <Controller
                            name="amusementServiceId"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange } }) => (
                              <SelectComponent
                                name="service"
                                className="w-100 mt-2"
                                variant="outlined"
                                size="small"
                                placeholder="انتخاب تفریح"
                                options={services?.map((item) => ({
                                  value: item.id,
                                  label: item.name,
                                }))}
                                value={getValues("amusementServiceId") || ""}
                                onChange={onChange}
                              />
                            )}
                          />
                          {errors.amusementServiceId && (
                            <div className="mt-2 pl-4 text-danger">**لطفا تفریح را وارد نمایید</div>
                          )}
                        </Col>

                        <Col xs="12" xl="6">
                          <Controller
                            name="title"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <TextField
                                label="عنوان"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                className="mt-5 mt-xl-2"
                                value={value || ""}
                                onInput={onChange}
                              />
                            )}
                          />
                          {errors.title && <div className="mt-2 pl-4 text-danger">**لطفا عنوان را وارد نمایید</div>}
                        </Col>

                        <Col xs="12" xl="12" className="mt-3 mb-2 font-size-sm">
                          <div className="mb-2">توضیحات قابل نمایش در tooltip</div>
                          <div>
                            {" "}
                            <Controller
                              name="tooltip"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextEditor
                                  data={value || ""}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    onChange(data);
                                  }}
                                />
                              )}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="rounded-2 px-3 py-1 pb-5 mt-5" style={{ border: "3px solid #81aced" }}>
                      <div
                        className="bg-white px-3 position-absolute d-inline-block text-primary"
                        style={{ marginTop: "-14px", width: "auto" }}
                      >
                        قیمت گذاری
       </div>
                      <Row className="mt-3">
                        <Col xs="12" xl="6">
                          <Controller
                            name="originalPrice"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <NumericFormat
                                customInput={TextField}
                                label="قیمت مصوب"
                                type="search"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                value={value || ""}
                                onChange={onChange}
                                thousandSeparator=","
                                onKeyDown={(e) => {
                                  if (e.key === "Escape") {
                                    e.stopPropagation()
                                  }
                                }}
                              />
                            )}
                          />
                          {errors.originalPrice && <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                        </Col>
                        <Col xs="12" xl="6">
                          <Controller
                            name="price"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { onChange, value } }) => (
                              <NumericFormat
                                customInput={TextField}
                                label="قیمت فروش"
                                margin="normal"
                                variant="outlined"
                                type="search"
                                size="small"
                                value={value || ""}
                                onChange={onChange}
                                thousandSeparator=","
                                onKeyDown={(e) => {
                                  if (e.key === "Escape") {
                                    e.stopPropagation()
                                  }
                                }}
                              />
                            )}
                          />
                          {errors.price && <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                        </Col>
                        <Col xs="12" xl="3">
                          <Controller
                            name="minimumReserveCountPerDay"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                label="حداقل تعداد"
                                type="text"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                value={field.value || ""}
                                onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                              />
                            )}
                          />
                        </Col>
                        <Col xs="12" xl="3">
                          <Controller
                            name="defaultReserveCountPerDay"
                            control={control}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => (
                              <TextField
                                label="ظرفیت روزانه"
                                type="text"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                value={field.value || ""}
                                onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                              />
                            )}
                          />
                          {errors.defaultReserveCountPerDay && (
                            <div className="mt-2 pl-4 text-danger">**لطفاظرفیت روزانه را وارد نمایید</div>
                          )}
                        </Col>
                        <Col xs="12" xl="6">
                          <Controller
                            name="reservationExpirationTime"
                            control={control}
                            rules={{ required: false }}
                            render={({ field: { onChange, value } }) => (
                              <PatternFormat
                                customInput={TextField}
                                label="ساعت اتمام فروش"
                                size="small"
                                type="search"
                                onKeyDown={(e) => {
                                  if (e.key === "Escape") {
                                    e.stopPropagation()
                                  }
                                }}
                                margin="normal"
                                value={value || ""}
                                variant="outlined"
                                onChange={onChange}
                                placeholder="00:00"
                                format="##:##"
                                allowEmptyFormatting={false}
                                defaultValue="23:59"
                              />
                            )}
                          />
                          {errors.reservationExpirationTime && (
                            <div className="mt-2 pl-4 text-danger">**لطفا ساعت اتمام فروش را وارد نمایید</div>
                          )}
                        </Col>
                        <Col xs="12" xl="6">
                          <Controller
                            name="executionTime"
                            control={control}
                            rules={{ required: false }}
                            render={({ field: { onChange, value } }) => (
                              <PatternFormat
                                customInput={TextField}
                                label="زمان انجام برنامه"
                                size="small"
                                margin="normal"
                                type="search"
                                onKeyDown={(e) => {
                                  if (e.key === "Escape") {
                                    e.stopPropagation()
                                  }
                                }}
                                value={value || ""}
                                variant="outlined"
                                onChange={onChange}
                                placeholder="00:00"
                                format="##:##"
                                allowEmptyFormatting={false}
                                defaultValue="23:59"
                              />
                            )}
                          />
                        </Col>
                        {/* <Col xs="12">
                           <Controller
                               name="defaultReserveCountPerDay"
                               control={control}
                               //rules={{ required: true }}
                               render={({ field: { onChange, value } }) => (
                                   <TextField
                                       label="حداکثر تعداد فروش در روز"
                                       margin="normal"
                                       variant="outlined"
                                       size="small"
                                       value={_.toInteger(value) || ""}
                                       onChange={onChange}
                                   />
                               )}
                           />
                          
                       </Col> */}

                        <Col xs="12" xl="6" className="d-flex align-items-center">
                          <Controller
                            name="reservationByPhone"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <TextField
                                label="تماس تلفنی"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                value={value || ""}
                                onInput={(e) => handleChangeIsNumber(e, onChange)}
                              />
                            )}
                          />
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-top">
                                در صورتی که این فیلد پر شود، آیتم موردنظر در سایت تفریحان قابل رزرو به صورت آنلاین نیست و
                                عنوان نمایشی « رزرو تلفنی » نمایش داده می شود.
               </Tooltip>
                            }
                          >
                            <i className="fa fa-info-circle ml-1 mt-1"></i>
                          </OverlayTrigger>
                        </Col>
                      </Row>
                    </div>
                    <div className="rounded-2 px-3 mt-5 py-1" style={{ border: "3px solid #81aced" }}>
                      <div
                        className="bg-white px-3 position-absolute d-inline-block text-primary"
                        style={{ marginTop: "-14px", width: "auto" }}
                      >
                        تسویه و صدور بلیط{" "}
                      </div>
                      <Row className="mt-3">
                        <Col xs="12" xl="6" style={{ zIndex: "3" }}>
                          <Controller
                            name="supplierId"
                            control={control}
                            render={({ field: { onChange } }) => (
                              <SelectComponent
                                name="supplierId"
                                className="w-100 mt-5"
                                variant="outlined"
                                size="small"
                                placeholder="تامین کننده"
                                options={suppliers?.map((item) => ({
                                  value: item.id,
                                  label: item.companyName,
                                }))}
                                value={getValues("supplierId") || ""}
                                onChange={onChange}
                              />
                            )}
                          />
                        </Col>
                        <Col xs="12" xl="6">
                          <Controller
                            name="supplierSettlementPrice"
                            control={control}
                            rules={{ required: supplierIdText ? true : false }}
                            render={({ field: { onChange, value } }) => (
                              <NumericFormat
                                customInput={TextField}
                                label="قیمت تسویه با تامین کننده"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                type="search"
                                value={value}
                                onChange={onChange}
                                thousandSeparator=","
                                onKeyDown={(e) => {
                                  if (e.key === "Escape") {
                                    e.stopPropagation()
                                  }
                                }}
                              />
                            )}
                          />
                          {errors.supplierSettlementPrice && (
                            <div className="mt-2 pl-4 text-danger">**قیمت تسویه با تامین کننده را وارد کنید</div>
                          )}
                          {/* {errorForSupplierSettlementPrice && (
             <div className="text-danger">**قیمت تسویه با تامین کننده را وارد کنید</div>
           )} */}
                        </Col>
                        <Col xs="12" xl="6">
                          <Controller
                            name="supplierSettlementType"
                            control={control}
                            // rules={{ required: true, }}
                            render={({ field: { onChange } }) => (
                              <SelectComponent
                                name="supplierSettlementType"
                                className="w-100 mt-2"
                                variant="outlined"
                                size="small"
                                placeholder="نحوه تسویه با تامین کننده"
                                options={supplierSettlementTypeEnum}
                                value={getValues("supplierSettlementType") || ""}
                                onChange={onChange}
                              />
                            )}
                          />
                        </Col>

                        <Col xs="12" xl="6">
                          <Controller
                            name="issueTicketType"
                            control={control}
                            // rules={{ required: true, }}
                            render={({ field: { onChange } }) => (
                              <SelectComponent
                                name="issueTicketType"
                                className="w-100 mt-3"
                                variant="outlined"
                                size="small"
                                placeholder="نوع صدور بلیط"
                                options={issueTicketTypeEnum}
                                value={getValues("issueTicketType") || ""}
                                onChange={onChange}
                              />
                            )}
                          />
                        </Col>

                        <Col
                          xs="12"
                          className={`pl-0 ${issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1 ? "opacity-50 " : ""}`}
                        >
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                name={"supplierAutoSettlement"}
                                render={({
                                  field: { onChange, onBlur, value, name, ref },
                                  fieldState: { invalid, isTouched, isDirty, error },
                                }) => (
                                  <Checkbox
                                    color="primary"
                                    onBlur={onBlur}
                                    onChange={onChange}
                                    checked={
                                      issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1
                                        ? false
                                        : value || false
                                    }
                                    inputRef={ref}
                                    disabled={
                                      issueTicketTypeSelect?.value === 2 && supplierSettlementTypeSelect?.value === 1
                                    }
                                  />
                                )}
                              />
                            }
                            label="تسویه خودکار با تامین کننده"
                          />
                        </Col>
                        {showMsg && (
                          <Col className="pb-3">
                            <div className="border-primary rounded-2 px-5 py-3 text-primary bg-light-primary">
                              تسویه با تامین کننده ی {supplierIdText?.label} به مبلغ{" "}
                              {supplierSettlementPriceformattedAmount} تومان به صورت خودکار انجام می شود.
             </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </Col>
                  <Col xl="6" className="mt-5 mt-xl-0">
                    <div className="rounded-2 px-3  py-1" style={{ border: "3px solid #81aced" }}>
                      <div
                        className="bg-white px-3 position-absolute d-inline-block text-primary"
                        style={{ marginTop: "-14px", width: "auto" }}
                      >
                        متن های درج شده روی بلیط{" "}
                      </div>
                      <Row className="mt-4">
                        <Col xs="12" xl="12" className=" mb-2 font-size-sm">
                          <div className="mb-2"> متن قوانین روی بلیط</div>
                          <div>
                            <Controller
                              name="ticketRules"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextEditor
                                  data={value || ""}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    onChange(data);
                                  }}
                                />
                              )}
                            />
                          </div>
                        </Col>

                        <Col xs="12" xl="12" className="mt-5 mb-5 font-size-sm">
                          <div className="mb-2"> متن توضیحات روی بلیط</div>
                          <div>
                            <Controller
                              name="ticketDescription"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextEditor
                                  data={value || ""}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    onChange(data);
                                  }}
                                />
                              )}
                            />
                          </div>
                        </Col>

                        <Col xs="12" xl="12" className="mt-5 pb-3 position-relative">
                          <div
                            className="bg-white font-size-sm position-absolute px-2"
                            style={{ top: "-10px", right: "20px" }}
                          >
                            متن نمایشی برنامه و سانس در بلیط
           </div>
                          <div className=" p-3" style={{ border: "1px solid #ccc", borderRadius: "2px" }}>
                            <FormControlLabel
                              className="mb-0"
                              control={
                                <Controller
                                  control={control}
                                  name={"showReserveItemGroupTitleInTicketPlan"}
                                  render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { invalid, isTouched, isDirty, error },
                                  }) => (
                                    <Checkbox
                                      color="primary"
                                      onBlur={onBlur}
                                      onChange={onChange}
                                      checked={value || false}
                                      inputRef={ref}
                                    />
                                  )}
                                />
                              }
                              label=" نمایش گروه آیتم رزرو در برنامه و سانس"
                            />{" "}
                            <FormControlLabel
                              className="mb-0"
                              control={
                                <Controller
                                  control={control}
                                  name={"showReserveItemTitleInTicketPlan"}
                                  render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { invalid, isTouched, isDirty, error },
                                  }) => (
                                    <Checkbox
                                      color="primary"
                                      onBlur={onBlur}
                                      onChange={onChange}
                                      checked={value || false}
                                      inputRef={ref}
                                    />
                                  )}
                                />
                              }
                              label=" نمایش عنوان آیتم رزرو در برنامه و سانس"
                            />
                            <div className="mb-1 mt-2">متن دلخواه در ادامه برنامه و سانس در بلیط</div>
                            <Controller
                              name="ticketPlanDetail"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextEditor
                                  data={value || ""}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    onChange(data);
                                  }}
                                />
                              )}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              }

            </Modal.Body>
            <Modal.Footer>
              {currentSteps === 0
                && <div className="d-flex gap-2">
                  <Button
                    variant="success"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    {modalType == 1 ? "ذخیره و مرحله بعدی" : "ذخیره"}
                  </Button>
                </div>
              }
              {
                currentSteps === 1 && <div className="d-flex gap-2">
                  <Button variant="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SaveIcon />
                    ذخیره و مرحله بعدی
                  </Button>
                </div>
              }
              {
                currentSteps === 2 && <div className="d-flex gap-2">
                  <Button variant="success" type="submit" disabled={isSubmitting}>
                    پایان عملیات
                  </Button>
                </div>
              }
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div >
  );
};

export default CreateOrEditAmusementReserveItem;
